import styled from 'styled-components';

import { colorScheme } from '../../theme';

// .hdn-link equivalent, will slowly transform into Styled Components for new code

export const A = styled.a<{ inline?: boolean }>`
  border: none;
  font-weight: 400;
  color: ${colorScheme.text.link};
  background: transparent;
  cursor: pointer;
  ${(props) =>
    props.inline
      ? ''
      : `
    font-size: 16px;
    line-height: 24px;
  `}
`;
